import { render, staticRenderFns } from "./EnvSwitcher.vue?vue&type=template&id=5dcde8bf"
import script from "./EnvSwitcher.vue?vue&type=script&lang=js"
export * from "./EnvSwitcher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.17_cache-loader@4.1.0_webpack@5.99.9__css-loader@6.1_ko473ranhrs7k4xxmt54qgngle/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports